import { getRelatedRoomState } from '../utils';

export const selectSearch = (state) => {
  return getRelatedRoomState(state).search;
};
